import { Tuple } from '../model/CommonModel';
import { Api } from './api';

class GraphicApi extends Api {
	public constructor() {
		super();
	}

	public retrieveMaps = async (pageNumber: number, pageSize: number): Promise<Tuple[]> => {
		const url = this.getUrl('Graphic/GetMaps', true);
		const data = {
			pageNumber,
			pageSize,
		};

		return await this.post<Tuple[]>(url, data);
	};
}

const graphicApi = new GraphicApi();

export { graphicApi };
